import {showNotification} from '@mantine/notifications';
import type {ReactNode} from 'react';
import {BsInfoSquareFill} from 'react-icons/bs';
import {ImCheckmark} from 'react-icons/im';
import {RiCloseFill, RiAlertFill} from 'react-icons/ri';
import {lightColors} from 'shared/assets/colors';

interface NotificationProps {
  title: string;
  message: string | ReactNode;
  onClick?: () => void;
}

export enum errorType {
  REJECTED = 'rejected',
}

export const successNotification = (props: NotificationProps) =>
  showNotification({
    ...props,
    color: 'white',
    icon: <ImCheckmark color={lightColors.success} />,
    styles: {
      root: {backgroundColor: lightColors.success},
      title: {color: 'white'},
      description: {color: 'white'},
      closeButton: {backgroundColor: 'white'},
    },
  });

export const errorNotification = (props: NotificationProps) =>
  showNotification({
    ...props,
    color: 'white',
    icon: <RiCloseFill color="red" />,
    styles: {
      root: {backgroundColor: 'red'},
      title: {color: 'white'},
      description: {color: 'white'},
      closeButton: {backgroundColor: 'white'},
    },
  });

export const warnNotification = (props: NotificationProps) =>
  showNotification({
    ...props,
    color: 'blue',
    icon: <RiAlertFill />,
  });

export const infoNotification = ({
  onClick,
  message,
  ...props
}: NotificationProps) =>
  showNotification({
    ...props,
    // Put the click handler only on the message/body area (so clicking X won't trigger it)
    message: onClick ? (
      <span
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        style={{cursor: 'pointer'}}>
        {message}
      </span>
    ) : (
      message
    ),
    // Extra safety: if Mantine supports it in your version, prevent bubbling from the close button too
    closeButtonProps: {
      onMouseDown: (e: any) => e.stopPropagation(),
      onPointerDown: (e: any) => e.stopPropagation(),
      onClick: (e: any) => e.stopPropagation(),
    } as any,
    color: '#228be6',
    icon: <BsInfoSquareFill size={30} />,
    styles: {
      root: {backgroundColor: '#228be6'},
      title: {color: 'white'},
      description: {color: 'white'},
      closeButton: {backgroundColor: 'white'},
    },
  });

export const requestErrorNotification = (
  errorMessage: string,
  title: string,
  message: string,
) => {
  switch (errorMessage) {
    case errorType.REJECTED:
      errorNotification({
        title,
        message,
      });

      break;
  }
};
